import axios from "axios";

const DICTIONARIES_URL = import.meta.env.VITE_DICTIONARIES_URL;

export const GetPersonTypeService = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const personTypeList = await axios.get(
        `${DICTIONARIES_URL}/v1/dictionary/getDictionaryList/TDP`
      );
      resolve(personTypeList.data);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
